import React, { Suspense, lazy, useEffect, useState } from "react";
import Tabs from "../Components/common/Tabs";
import Loader from "../Components/common/Loader";
import { ASSETS, IFRAME_MODULE_CONFIG, TAB_ENUM, TAB_OPTIONS } from "../Components/common/config";
import { getDynamicTab, getDynamicTabImage } from "../utils/getDynamicTab";
import centralAPI from "../CentralAPIHandler/CentralAPIHandler";
import { getParams } from "../utils/getParams";
import { transformedSku360Data } from "../utils/transformAPIData";
import { IMAGE_COMPRESSOR } from "../utils/imageCompressor";
import View3D from "../Components/threeD/View3D";
import { ChevronRightArrow } from "../Components/threeD/common/svgs";


const View360Common = lazy(() => import("../Components/View360/View360Common"));
const Video = lazy(() => import("../Components/Video/Video"));
const Gallery = lazy(() => import("../Components/gallery/Gallery"));


const CommonIframeHome = () => {
  
  const [skuData, setSkuData] = useState([]);
  const [hideBottomTabs, setHideBottomTabs] = useState(false);
  const [_360Data, set360Data] = useState({});
  const [loading, setLoading] = useState(false);
  const [dynamicTab, setDynamicTab] = useState([]);
  const [dynamicTabImage, setDynamicTabImage] = useState([]);
  const [selectedTab, setSelectedTab] = useState(TAB_ENUM.THREE_SIXTY_VIEW);
  const {params} = getParams()
  const [collapsed, setCollapsed] = useState(window.innerWidth >= 1024);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(()=>{
    if(selectedTab === TAB_ENUM.VIEW_3D){
      setHideBottomTabs(true);
    }
  },[selectedTab]);

  useEffect(() => {
    const fetchApidata = async () => {
      try {
        setLoading(true)
        const response = await centralAPI.handleGetRequest(`${process.env.REACT_APP_BASEURL_API_SPYNE}/api/nv1/hotspot/sku-data`, params); 

        // const response = await centralAPI.handleGetRequest(`http://localhost:1337/api/nv1/hotspot/sku-data`, params); 
        setSkuData(response?.data)
        set360Data(transformedSku360Data(response?.data))
        const getTabBasedOnConfig = getDynamicTab(response?.data)
        setDynamicTab(getTabBasedOnConfig);
        setDynamicTabImage(getDynamicTabImage(response?.data?.image));
        setLoading(false)
        if (getTabBasedOnConfig.length > 0) {
          setSelectedTab(getTabBasedOnConfig[0].key);
        }
      } catch (error) {
        setLoading(false)
      } finally {
        setLoading(false)
      }
    };

    fetchApidata();
  }, []);
  
  return (
    <div className=" flex flex-col items-center justify-center h-full w-full transition-all duration-700 ease-in">
      <div className=" relative rounded-md h-full w-full">
        {(!loading && (skuData?.status?.toLowerCase() !== IFRAME_MODULE_CONFIG.isSkuDone)) ? 
          <img className="w-full h-full max-sm:object-contain" src={IMAGE_COMPRESSOR({url:ASSETS.other.noSkuDone})} alt="vin is in process"/>
          :
          <>
          <div onClick={()=>setCollapsed(true)}>
        {loading ? 
        <Loader/>
        :
          <Suspense fallback={<Loader showPageName={selectedTab} />}>
          {selectedTab === TAB_ENUM.THREE_SIXTY_VIEW ? (
            <View360Common data={_360Data}/>
          ) : selectedTab === TAB_ENUM.VIDEO_VIEW ? (
            <Video videoUrl={skuData?.video} tabLength={dynamicTab?.length}/>
          ) : selectedTab === TAB_ENUM.GALLERY_VIEW ? (
            <Gallery galleryData={Object.values(skuData?.image).flat()} tabLength={dynamicTab?.length} dynamicTabImage={dynamicTabImage}/>
          ) : selectedTab === TAB_ENUM.VIEW_3D? (
            <div className="h-screen w-full">
              <View3D common={true} hideBottomTabs={hideBottomTabs} setHideBottomTabs={setHideBottomTabs}/>
            </div>
          ): null}
        </Suspense>}
        </div>
       {(dynamicTab?.length > 0) && !hideBottomTabs &&
       <div className={`fixed bottom-0 ${selectedTab === TAB_ENUM.VIDEO_VIEW ? "md:bottom-[10%]" : "md:bottom-[4.2%]"} left-0 md:left-12 transition-all duration-300 ease-in-out`}>
       <div className="flex items-center">
         <div className={`bg-white-35 shadow-md shadow-black-8 sm:rounded-b-md md:rounded-xl max-md:w-full md:w-max z-50 lg:shadow-md transition-all duration-300 ease-in-out`}>
            <Tabs
              options={dynamicTab}
              onSelect={(option) => setSelectedTab(option.key)}
              collapsed={isLargeScreen ? collapsed : false}
            />
          </div>
           {
            isLargeScreen && collapsed && 
              <button className='text-sm text-black-80 h-full flex justify-center items-center ml-2' onClick={()=>setCollapsed(false)}>
                <ChevronRightArrow className="h-3 w-3 z-50 shadow-lg" fill={`black`} />
              </button>
           }
        </div>   
        </div>  
        }
        </>
        }
      </div>
    </div>
  );
};

export default CommonIframeHome;
